import * as bi from 'react-bootstrap-icons';
import { IClientTripBrief, IClientTripSearchFull, IClientTripSearchBackFull } from '@bustickus/models-client';
import { Box, Flex, Header } from 'components';
import { TripCard } from '..';
import './style.scss';

interface IProps {
  searchResult: IClientTripSearchFull | null | undefined;
  aCityId: string | null | undefined;
  dCityId: string | null | undefined;
}

function TripList(props: IProps) {
  if (props.searchResult == null || props.searchResult.trips.length === 0) {
    return (
      <Flex direction='column'>
        <NoTrips />
        <div className='filler-trip-list-MajHa'></div>
      </Flex>
    );
  }

  return (
    <Flex
      gap={10}
      direction='column'
    >
      {props.searchResult.trips.map((x) => (
        <TripCard
          key={x.id}
          trip={x}
          back={createValidTripBack(x, props.searchResult?.back)}
          aCityId={props.aCityId}
          dCityId={props.dCityId}
        />
      ))}
      <div className='filler-trip-list-MajHa'></div>
    </Flex>
  );
}

function NoTrips() {
  return (
    <Box padding={20}>
      <Flex
        gap={20}
        direction='column'
      >
        <Header>Поиск рейсов</Header>
        <Flex
          gap={20}
          direction='column'
          alignItems='center'
        >
          <div className='no-trips-icon'>
            <bi.Search />
          </div>
          <div>Не найдено ни одного рейса</div>
          <div className='no-trips-filler-rosa' />
        </Flex>
      </Flex>
    </Box>
  );
}

function createValidTripBack(
  trip: IClientTripBrief,
  back: IClientTripSearchBackFull | null | undefined
): IClientTripSearchBackFull | null {
  if (back == null) {
    return null;
  }

  const aDateMs = new Date(trip.arrival?.arrivalDate ?? 0).getTime();

  const validTrips = back.trips.filter(
    (x) => new Date(x.departure?.departureDate ?? 0).getTime() > aDateMs && x.tickets > 0
  );

  return {
    trips: validTrips,
    date: back.date,
  };
}

export default TripList;
